<template>
  <div
    class="sj-switch"
    :class="[`switch-size-${size}`, { disabled, loading }]"
  >
    <div class="switch-label" v-if="label">
      {{ label }}
    </div>
    <div
      class="switch-button"
      :class="{ checked: value }"
      @click.stop="handleClick"
    >
      <span class="switch-round">
        <span class="switch-loading-circle" v-if="loading"></span>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * switch组件
 */
import sizeMixin from "../../../utils/sizeMixin";

export default {
  name: "SjSwitch",
  mixins: [sizeMixin],
  props: {
    label: String,
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "default",
      validator(v) {
        return ["default", "small"].indexOf(v) !== -1;
      }
    }
  },
  methods: {
    handleClick() {
      if (!this.disabled && !this.loading) {
        this.$emit("input", !this.value);
        this.$emit("change", !this.value);
      }
    }
  }
};
</script>

<style scoped lang="less">
@default-size: 20px;
@small-size: 16px;
@round-padding: 2px;
.sj-switch {
  display: inline-flex;
  align-items: center;

  &.switch-size-default {
    .switch-label {
      .text("body", "subinfo");
    }

    .switch-button {
      height: @default-size;
      width: @default-size*2;
      border-radius: @default-size / 2;
      @round-size: @default-size - 4px;
      .switch-round {
        width: @round-size;
        height: @round-size;
        .switch-loading-circle {
          top: @round-size / 2 - 5px;
        }
      }
      &.checked {
        .switch-round {
          margin-left: -(@round-size+ @round-padding);
        }
      }
    }
  }

  &.switch-size-small {
    .switch-label {
      .text("caption", "subinfo");
    }

    .switch-button {
      height: @small-size;
      width: @small-size*2;
      border-radius: @small-size / 2;
      @round-size: @small-size - 4px;
      .switch-round {
        width: @round-size;
        height: @round-size;
        .switch-loading-circle {
          top: @round-size / 2 - 5px;
        }
      }
      &.checked {
        .switch-round {
          margin-left: -(@round-size+ @round-padding);
        }
      }
    }
  }

  .switch-label {
    margin-right: 4px;
  }

  .switch-button {
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    background-color: @color-light;
    .switch-round {
      border-radius: 50%;
      background-color: @color-antibg;
      transition: all 0.3s;
      top: @round-padding;
      left: @round-padding;
      position: absolute;
    }
    &.checked {
      background-color: @color-highlight;
      .switch-round {
        left: 100%;
      }
    }
  }

  &.disabled {
    .switch-label {
      color: @color-light;
    }
    .switch-button {
      cursor: not-allowed;
      background-color: @color-gray-3;
    }
  }

  &.loading {
    .switch-button {
      cursor: not-allowed;
      .switch-round {
        .switch-loading-circle {
          position: absolute;
          background-color: @color-highlight;
          @loading-circle-size: 4px;
          width: @loading-circle-size;
          height: @loading-circle-size;
          border-radius: 50%;
          right: 50%;
          transform: translateX(-@loading-circle-size / 2);
        }
        animation: loadingCircle 1s infinite linear;
        @keyframes loadingCircle {
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}
</style>
